export const service = 138;
export const efectiveSena = 15;
export const discountId = 17;
export const finalConsumerId = 2;
